import { render, staticRenderFns } from "./basic-modal-window.vue?vue&type=template&id=0b5a8e38"
import script from "./basic-modal-window.vue?vue&type=script&lang=js"
export * from "./basic-modal-window.vue?vue&type=script&lang=js"
import style0 from "./basic-modal-window.vue?vue&type=style&index=0&id=0b5a8e38&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./basic-modal-window.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports